import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from 'src/app/route-animate';
// import { ValueService } from 'src/app/services/value.service';
// declare let $: any;
@Component({
  selector: 'app-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrls: ['./layout-page.component.css'],
  animations: [slideInAnimation],
})
export class LayoutPageComponent implements OnInit {
  constructor() {}
  // private getdata:ValueService
  ngOnInit(): void {
    document.getElementById('css').setAttribute('href', 'assets/css/home.css');

    // $(document).ready(function () {
    //   $(window).on('scroll', function () {
    //     if ($(this).scrollTop() > 100) {
    //       $('#back-to-top').fadeIn();
    //     } else {
    //       $('#back-to-top').fadeOut();
    //     }
    //   });
    //   $('#back-to-top').click(function () {
    //     $("html, body").animate({
    //       scrollTop: 0
    //     }, 600);
    //     return false;
    //   });
    // });
  }
}
